export default __webpack_public_path__ + "static/media/jump.c7def384.svg";